import type { CustomStoreImplementationOptions, KaElementMap, MergeCustomStore, StoreIdentifier } from 'kapix-components-vue3'
import { defineStore } from 'pinia'
import { initAliveStoreIds, kapixContext, navigateTo, openUrl, remove } from 'kapix-components-vue3'
import donneesPersonnellesStoreCustom from './store.custom'
import { $translate } from '~/modules/i18n'

const storeName = 'donneesPersonnelles'
const customImplement: CustomStoreImplementationOptions = donneesPersonnellesStoreCustom.options
const aliveStoreIds = initAliveStoreIds()

function donneesPersonnellesFactory (storeId?: Nullable<StoreIdentifier>) {
  return defineStore(storeId == null ? storeName : `${storeName}/${storeId}`, {
    state: () => {
      return {
        $aliveStoreIds: aliveStoreIds,
        $subStoreIds: 1,
        $storeId: storeId,
        $emit: (() => {}) as (propName: any, value: any) => void,
        $elements: {} as KaElementMap,
        $router: kapixContext.isClient ? kapixContext.$router : undefined,
        $route: kapixContext.isClient ? kapixContext.$route : undefined,
        // Page info,
        $title: $translate('page-rgpd-review.title', 'Données personnelles'),
        $description: $translate('page-rgpd-review.description', ''),
        $publishedTime: new Date('2023-02-13T07:42:17.665Z'),
        $modifiedTime: new Date('2023-05-31T09:49:18.151Z'),
        // Constants,
        $constants: {},
        // Data,
        $data: { switchPourquoiMatchers: 0 as Nullable<number> },
        ...(customImplement.state && customImplement.state())
      }
    },
    getters: {
      ...customImplement.getters
    },
    actions: {
      /* @ts-ignore: to allow override in your custom file */
      text1Click () {
        this.$data.switchPourquoiMatchers = 0
      },
      /* @ts-ignore: to allow override in your custom file */
      text2Click () {
        this.$data.switchPourquoiMatchers = 1
      },
      /* @ts-ignore: to allow override in your custom file */
      text3Click () {
        this.$data.switchPourquoiMatchers = 2
      },
      /* @ts-ignore: to allow override in your custom file */
      text4Click () {
        this.$data.switchPourquoiMatchers = 3
      },
      /* @ts-ignore: to allow override in your custom file */
      prendreRendezVousClick () {
        openUrl('https://www.matchers.fr/faq', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      async button1Click () {
        await navigateTo({ name: 'Contact' })
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        return storeId != null ? getStoreInstance(storeId) : this
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstances () {
        return aliveStoreIds.map(storeId => this.getStoreInstance(storeId))
      },
      /* @ts-ignore: to allow override in your custom file */
      newStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        const newStoreId = storeId || this.$subStoreIds++
        if (aliveStoreIds.includes(newStoreId)) {
          throw new Error(`Store with id ${storeId} already exists`)
        }
        aliveStoreIds.push(newStoreId)
        return getStoreInstance(newStoreId)
      },
      ...customImplement.actions,
      /* @ts-ignore: to allow override in your custom file */
      beforeMount () {
        customImplement.actions?.beforeMount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      mounted () {
        customImplement.actions?.mounted?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      async serverPrefetch () {
        await customImplement.actions?.serverPrefetch?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      beforeUnmount () {
        customImplement.actions?.beforeUnmount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      unmounted () {
        if (this.$storeId != null) {
          this.$dispose()
          remove(aliveStoreIds, this.$storeId)
        }
        customImplement.actions?.unmounted?.call(this)
      }
    }
  })
}

function getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
  return donneesPersonnellesFactory(storeId)()
}

export const donneesPersonnellesRaw = donneesPersonnellesFactory()
export const donneesPersonnelles = () => donneesPersonnellesRaw() as MergeCustomStore<typeof donneesPersonnellesStoreCustom.instance>
